// extracted by mini-css-extract-plugin
export default {"cross-icon-position":"ApplicationCategory_cross-icon-position__NtMgh","btn-position":"ApplicationCategory_btn-position__6lt8p","heading":"ApplicationCategory_heading__Hr81D"};